export const scrollXDataTable = async (screenWidth,columnNumber) =>{
    var elements = document.getElementsByClassName('react-bootstrap-table');

    let isMouseDown = false;
    let startX;
    let scrollLeft;

    for (let i = 0; i < elements.length; i++) {
        // width: max-content + min-width: 100% : le tableau occupe au minimum tout l'espace disponible, et ne déborde (avec scroll) que si son contenu réel a besoin de plus de place. Plus fiable qu'un seuil de nombre de colonnes par résolution d'écran, qui ne reflète pas la largeur réelle du contenu
        elements[i].style.width = 'max-content';
        elements[i].style.minWidth = '100%';

        // Ajoutez un conteneur pour le tableau qui a une hauteur et une largeur spécifiées pour permettre le défilement.
        let container = document.createElement('div');        
        container.className = 'table-wrapper container-table-scroll';
        container.style.overflowX = 'scroll'; 
        container.style.zIndex = '1';
        container.setAttribute('oncontextmenu', 'return false;');
        
        // Vérifier si le conteneur a déjà été créé pour cet élément, il regardera si un conteneur existe avec les class '.container-table-scroll', si oui il ne recréera plus de conteneur
        if (!elements[i].closest('.container-table-scroll')) {
            elements[i].parentElement.insertBefore(container, elements[i]);
            container.appendChild(elements[i]);
        }

        container.addEventListener('mousedown', (event) => {
            if(event.button==2){
                event.preventDefault();
                isMouseDown = true;
                startX = event.pageX - container.offsetLeft;
                scrollLeft = container.scrollLeft;
                container.style.cursor = 'grabbing';
            }
        });

        container.addEventListener('mouseleave', (event) => {
            isMouseDown = false;    
        });
        
        container.addEventListener('mouseup', (event) => {
            isMouseDown = false;    
            container.style.removeProperty('cursor');
        });
        
        container.addEventListener('mousemove', (event) => {
            if (!isMouseDown) return
            event.preventDefault();
            const x = event.pageX - container.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            container.scrollLeft = scrollLeft - walk;
        });
        
    }
}